export default __webpack_public_path__ + "static/media/dmgfile-install.3bb5cddf.jpg";